import {Pipe, PipeTransform} from '@angular/core';

/**
 * Generated class for the PositionChangeValuePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'positionChangeValue',
})
export class PositionChangeValuePipe implements PipeTransform {
  transform(change) {
    if (isNaN(change) || change === 0 || change === null) {
      return 0;
    }
    else {
      return change;
    }
  };
}



// WEBPACK FOOTER //
// ./src/shared/pipes/position-change-value/position-change-value.ts